import { render, staticRenderFns } from "./MainMobileLayout.vue?vue&type=template&id=0c1b0c98&"
import script from "./MainMobileLayout.vue?vue&type=script&lang=js&"
export * from "./MainMobileLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports